import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApidataService } from '../apidata.service';
import { environment } from '../../environments/environments';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
@Component({
  selector: 'app-premium',
  standalone: true,
  templateUrl: './premium.component.html',
  styleUrls: ['./premium.component.css'],
  imports: [CommonModule, TranslateModule],
})
export class PremiumComponent implements OnInit {
  @Input() heading: boolean = true;
  loaded: boolean = false;
  hidePremium: boolean = false;

  plans = [
    {
      id: 'price_1Q6AFpIcvPV98dDokZi78LKx',
      name: 'Monthly',
      title: 'Monthly',
      price: '$7.50',
      amount: '$7.50',
      originalPrice: '$15.00',
      discount: '50%',
    },
  ];

  constructor(
    private apiDataService: ApidataService,
    private router: Router,
    private languageService: LanguageService
  ) {
    //
  }

  ngOnInit(): void {
    const profile_id = localStorage.getItem('profile_id');

    if (!profile_id || profile_id === '1' || !this.heading) {
      this.loaded = true;
      return;
    }

    this.apiDataService
      .postResources(
        JSON.stringify({ user_id: profile_id }),
        environment.API_URL + '/api/checkSubscriptionStatus'
      )
      .subscribe((data) => {
        if (data['response'][0] === 'premium_user') {
          this.hidePremium = true;
        }

        this.loaded = true;
      });
  }

  selectPlan(e: Event, id: string) {
    e.preventDefault();
    const plan = this.plans.find((plan) => plan.id === id);
    localStorage.setItem('price_id', id);
    localStorage.setItem('plan', plan.title);
    localStorage.setItem('amount', plan.amount);

    window.open('/plans', '_blank');
  }

  redirectToAccount(e: Event) {
    e.preventDefault();
    this.router.navigate(['/accountsettings'], {
      queryParams: { ref: 'premium' },
    });
  }
  getLocalizedImagePath(imageBaseName: string): string {
    const lang = this.languageService.selectedLanguage?.code || 'en';
    return lang === 'en'
      ? `/assets/images/illustration/${imageBaseName}-${lang}.svg`
      : `/assets/images/illustration/${imageBaseName}-${lang}.svg`;
  }
}
